// Каталог роутеров. Вынесен из RouterModule, потому что теперь нужен
// в двух местах: страница /router и блок «Роутеры и оборудование» на главной.
// Порядок важен — главная берёт первые три в наличии.
import React from "react";
import { FiDownload } from "react-icons/fi";

import routerImg from "../../Assets/Router/img/gp1704-2g-22a.jpg";
import routerImg2 from "../../Assets/Router/img/preview.png";
import routerImg3 from "../../Assets/Router/img/router.png";
import routerImg4 from "../../Assets/Router/img/eg8021v5.png";
import routerImg5 from "../../Assets/Router/img/eg8041x6-10.png";
import routerImg6 from "../../Assets/Router/img/eg8245x6-8n-30.png";

import iptvImg from "../../Assets/Router/img/iptv.svg";
import cameraImg from "../../Assets/Router/img/camera-p3b-pv.png";
import cameraImg2 from "../../Assets/Router/img/camera-c5a.png";
import cameraImg3 from "../../Assets/Router/img/camera-h3b.png";
import cameraImg4 from "../../Assets/Router/img/4.png";

export const routers = [
  {
    id: 6,
    img: routerImg6,
    title: "Huawei OptiXstar EG8245X6-8N-30",
    subTitle: "GPON-роутер Wi-Fi 6",
    isNew: true,
    lan: "4×GE LAN, 2×TEL, USB",
    wifi: "Wi-Fi 6 (802.11ax), 2.4 + 5 ГГц",
    speed: "Скорость передачи данных:",
    purity: "Частота 2,4 ГГц + 5 ГГц",
    puritySpeed: "двухдиапазонный",
    price: "1 150 TJS",
    oldPrice: "1 400 TJS",
    installment: "Рассрочка: 6 мес — 230 с/мес, 12 мес — 125 с/мес",
    download: "Скачать полную информацию",
    downloadIcon: <FiDownload className="download_icon" />,
  },
  {
    id: 5,
    img: routerImg5,
    title: "Huawei OptiXstar EG8041X6-10",
    subTitle: "GPON-роутер Wi-Fi 6",
    isNew: true,
    lan: "4×GE LAN",
    wifi: "Wi-Fi 6 (802.11ax), 2×2 MIMO",
    speed: "Скорость передачи данных:",
    purity: "Частота 2,4 ГГц",
    puritySpeed: "до 574 Мбит/с",
    purityBottom: "Частота 5 ГГц",
    puritySpeedBottom: "до 2402 Мбит/с",
    price: "400 TJS",
    oldPrice: "580 TJS",
    installment: "Рассрочка: 6 мес — 80 с/мес, 12 мес — 45 с/мес",
    download: "Скачать полную информацию",
    downloadIcon: <FiDownload className="download_icon" />,
  },
  {
    id: 4,
    img: routerImg4,
    title: "Huawei EchoLife EG8021V5",
    subTitle: "GPON-роутер Wi-Fi 5",
    isNew: true,
    lan: "2×GE LAN",
    wifi: "Wi-Fi 5 (802.11ac), 2×2 MIMO",
    speed: "Скорость передачи данных:",
    purity: "Частота 2,4 ГГц",
    puritySpeed: "до 300 Мбит/с",
    purityBottom: "Частота 5 ГГц",
    puritySpeedBottom: "до 867 Мбит/с",
    price: "320 TJS",
    oldPrice: "550 TJS",
    installment: "Рассрочка: 6 мес — 65 с/мес, 12 мес — 35 с/мес",
    download: "Скачать полную информацию",
    downloadIcon: <FiDownload className="download_icon" />,
  },
  {
    id: 3,
    img: routerImg3,  // Замените на изображение третьего роутера
    title: "ONU (BDCOM -GP1705-2GV)",
    subTitle: "Беспроводной маршрутизатор",
    lan: "5xGE RJ45",
    wifi: "IEEE 802.11a/b/g/n, 802.11ac Wave 2",
    speed: "Скорость передачи данных:",
    purity: "Частота 2,4 ГГц",
    puritySpeed: "до 450Мбит/с",
    purityBottom: "Частота 5 ГГц",
    puritySpeedBottom: "до 1300Мбит",
    price: "550 TJS",
    installment: "Имеется рассрочка на 9/18 месяцев без первого взноса",
    download: "Скачать полную информацию",
    in_stock: false,
    downloadIcon: <FiDownload className="download_icon" />,
  },
  {
    id: 2,
    img: routerImg2,  // Замените на изображение второго роутера
    title: "Роутер с поддержкой 733 Мбит/с",
    subTitle: "Роутер",
    lan: "Гигабитные порты LAN",
    wifi: "Общая пропускная способность до 733 Мбит/с",
    speed: "Скорость передачи данных:",
    purity: "Частота 2,4 ГГц",
    puritySpeed: "300 Мбит/с",
    purityBottom: "Частота 5 ГГц",
    puritySpeedBottom: "433 Мбит/с",
    price: "350 TJS",
    installment: "Имеется рассрочка на 9/18 месяцев без первого взноса",
    download: "Скачать полную информацию",
    downloadIcon: <FiDownload className="download_icon" />,
  },
  {
    id: 1,
    img: routerImg,
    title: "BDCOM GP1704-2F-E",
    subTitle: "Роутер",
    lan: "Гигабитные порты LAN",
    wifi: "Двухдиапазонный Wi-Fi",
    speed: "Скорость передачи данных:",
    purity: "Частота 2,4 ГГц",
    puritySpeed: "100 Мбит/с",
    purityBottom: "",
    puritySpeedBottom: "",
    price: "450 TJS",
    installment: "Рассрочка на 9/18 месяцев без первого взноса",
    download: "Скачать полную информацию",
    in_stock: false,
    downloadIcon: <FiDownload className="download_icon" />,
  },
];

export const iptv = [

  {
    id: 1,
    img: iptvImg,
    title: "X7 plus",
    subTitle: "Приставка",
    lan: "OS: Android 9",
    wifi: "RAM: 4/32GB",
    speed: "WiFi: 2.4/5G",
    purity: "Bluetooth", 
    purityBottom: "Network: Gigabit", 
    led: "LED Display", 
    price: "550 TJS", 
    in_stock: false
  },

];

export const cameras = [

  {
    id: 1,
    img: cameraImg,
    title: "WIFI видеокамера Dahua DH-P3B-PV (уличная)",
    subTitle: "Камера",
    lan: "Бренд: DAHUA",
    wifi: "Тип Видеокамер: Pan & Tilt",
    speed: "Камера разрешение: 3MP",
    purity: "Фокусное расстояние: 2.8mm",
    purityBottom: "Инфракрасная подсветка: 30 m (Warm light)",
    price: "750 TJS",

  },
  {
    id: 2,
    img: cameraImg2,  
    title: "WIFI видеокамера Dahua DH-C5A",
    subTitle: "Камера",
    lan: "Тип видеокамер: Компактные",
    wifi: "Камера Разрешение: 3MP/5MP",
    speed: "Камера Фокусное расстояние: 2.8mm",
    purity: "Камера Инфракрасная подсветка:	-10m", 
    purityBottom: "Камера Поддержка аудио:	Speaker, Built-in Mic", 
    price: "510 TJS", 
  },
  {
    id: 3,
    img: cameraImg3,   
    title: "WIFI видеокамера Dahua DH-H3B",
    subTitle: "Камера",
    lan: "Сжатие видео: Н.265",
    wifi: "WDR: DWDR",
    speed: "Сжатие звука: Г.711а",
    purity: "Энергопотребление: Базовый 1,6 Вт", 
    purityBottom: "Угол наклона: от -5° до 80°", 
    price: "560 TJS", 
  },
  {
    id: 4,
    img: cameraImg4,   
    title: "IP Dahua PT WiFi DH-P3AE-PV (уличная)",
    subTitle: "Камера",
    lan: "Матрица: 1/2.8 КМОП, 3 Мп",
    wifi: "Эффективные пиксели (Г×В) : 2304×1296",
    speed: "Электронный затвор: 1 с ~ 1/100000 с",
    purity: "Модуль подсветки: 2 ИК-диода", 
    purityBottom: "Фокусное расстояние: 4 мм", 
    price: "750 TJS", 
  },
];
